import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, output, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormValidations, FormValidationsDictionary, FormValidationTypes } from '@shared/models/form-validations';
import { AngularModule, MaterialModule } from '@shared/modules';

@Component({
  selector: 'app-generic-text',
  standalone: true,
  imports: [AngularModule, MaterialModule],
  templateUrl: './generic-text.component.html',
  styleUrl: './generic-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericTextComponent {
  @Input() label: string = '';
  @Input() allowKeyEnterEvent: boolean = false;
  @Output() keyEnterEvent = new EventEmitter<void>();
  control = input.required<FormControl>();
  isClear = input<boolean>(true);
  @Input() validations: Partial<Record<FormValidationTypes, FormValidations> | null> = null;
  clearInput = output<void>();
  formValidationsDictionary = FormValidationsDictionary;

  onKeyDown(event: KeyboardEvent): void {
    const key = event.key;

    if (key === 'Enter' && this.allowKeyEnterEvent) {
      this.keyEnterEvent.emit();
    }
  }
  clear(): void {
    this.control().setValue('');
    this.clearInput.emit();
  }
}
